import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = ["id", "name", "value", "disabled", "required", "data-test-value"]
const _hoisted_3 = ["aria-checked", "aria-required", "aria-disabled", "aria-invalid", "aria-labelledby"]
const _hoisted_4 = ["data-test"]
const _hoisted_5 = ["innerHTML", "id"]
const _hoisted_6 = {
  key: 0,
  class: "ds-checkbox__message"
}

import { computed, ComputedRef, ref, useAttrs } from "vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { DsFormFieldValueType } from "../models/ds-form-field-models";
import { DsCheckboxListOptionModel } from "./ds-checkbox-option/ds-checkbox-option-models";


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ds-checkbox-option',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    value: {},
    label: {},
    supportingText: {},
    required: { type: Boolean },
    disabled: { type: Boolean },
    dataTest: {},
    dataTestValueInput: {},
    dataTestLabel: {},
    name: {},
    isInStorybook: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const props = __props;


const { class: wrapperClass, ...attrs } = useAttrs();

/**
 * Model for the checkbox value. All checkboxes store their values in an array if is checked.
 */
const modelValue = _useModel<T[]>(__props, "modelValue");
const errorMessages = ref<string[]>([]);

const isValid = computed(() => !errorMessages.value.length);
const isChecked = computed(() => modelValue.value.includes(props.value));

__expose<{ isChecked: ComputedRef<boolean> }>({
    isChecked,
});

const checkboxKeydownEventHandler = (event: KeyboardEvent) => {
    if (!props.disabled && (event.key === "Enter" || event.key === "Space")) {
        if (isChecked.value) {
            const valueIndex = modelValue.value.indexOf(props.value);
            modelValue.value.splice(valueIndex, 1);
        } else {
            modelValue.value.push(props.value);
        }
    }
};

const ariaLabelId = computed(() => `label-${props.id.replace(/\s+/g, "-").toLowerCase()}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["ds-checkbox", [{ disabled: _ctx.disabled, 'has-error': !isValid.value, checked: isChecked.value }, _unref(wrapperClass)]]),
    "data-test": _ctx.dataTestLabel
  }, [
    _withDirectives(_createElementVNode("input", _mergeProps({
      type: "checkbox",
      class: "ds-checkbox__input",
      id: _ctx.id,
      name: _ctx.name,
      value: _ctx.value,
      disabled: _ctx.disabled,
      required: _ctx.required,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
    }, attrs, { "data-test-value": _ctx.dataTestValueInput }), null, 16, _hoisted_2), [
      [_vModelCheckbox, modelValue.value]
    ]),
    _createElementVNode("div", {
      class: "ds-checkbox__checkbox",
      tabindex: "0",
      onKeydown: checkboxKeydownEventHandler,
      role: "checkbox",
      "aria-checked": isChecked.value,
      "aria-required": _ctx.required,
      "aria-disabled": _ctx.disabled,
      "aria-invalid": !isValid.value,
      "aria-labelledby": ariaLabelId.value
    }, [
      _createVNode(DsIcon, {
        width: 16,
        height: 16,
        name: "check",
        class: "ds-checkbox__checkmark",
        "is-in-storybook": _ctx.isInStorybook
      }, null, 8, ["is-in-storybook"])
    ], 40, _hoisted_3),
    _createElementVNode("div", {
      class: "ds-checkbox__texts",
      "data-test": _ctx.dataTest
    }, [
      _createElementVNode("span", {
        class: "ds-checkbox__label",
        innerHTML: _ctx.label,
        id: ariaLabelId.value
      }, null, 8, _hoisted_5),
      (_ctx.supportingText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.supportingText), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_4),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})